import React, { FC } from "react";
import { H6, Span } from "../../../Typography";
import StatusBtn from "../../StatusBtn";
import { Box, Button, Grid } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { he } from "date-fns/locale";
import FlexBox from "../../../FlexBox";
import { figureFormatter } from "../../../../utils/figure_formatter";

interface ResultsNINProps {
  data: any;
  handleTryAgain?: () => void;
}

const ResultsNIN: FC<ResultsNINProps> = ({ data, handleTryAgain }) => {
  return (
    <Box>
      <Box sx={styles.container} marginBottom={2}>
        <FlexBox gap={2} alignItems={"center"}>
          <Box sx={styles.iconCircle}>
            <AccountCircleIcon
              color="primary"
              sx={{ height: "3.8rem", width: "3.8rem" }}
            />
          </Box>
          <FlexBox flexDirection={"column"} gap={0.8}>
            <H6 marginBottom={0}>NIN:</H6>
            <Span sx={styles.labelValue}>{data?.parameter?.nin}</Span>
          </FlexBox>
        </FlexBox>
        <FlexBox
          flexDirection={"column"}
          gap={0.8}
          sx={{ textAlign: "center" }}
        >
          <H6 marginBottom={0}>NIN Status:</H6>
          <StatusBtn
            type={
              data?.result?.status === "FAILED" || data?.status === 5 ? 0 : 1
            }
            title={
              data?.result?.status === "FAILED" || data?.status === 5
                ? data?.result?.message || "FAILED"
                : "FOUND"
            }
          />
        </FlexBox>
      </Box>

      <Box sx={styles.container} marginBottom={2}>
        <Grid container rowSpacing={2.5}>
          <Grid item xs={6}>
            <H6 marginBottom={0} sx={styles.labelText}>
              Name
            </H6>
            <Span sx={styles.labelValue}>
              {data?.result?.name ? data?.result?.name : "---"}
            </Span>
          </Grid>
          <Grid item xs={6}>
            <H6 marginBottom={0} sx={styles.labelText}>
              Date of Birth
            </H6>
            <Span sx={styles.labelValue}>
              {data?.result?.date_of_birth
                ? data?.result?.date_of_birth
                : "---"}
            </Span>
          </Grid>
          <Grid item xs={6}>
            <H6 marginBottom={0} sx={styles.labelText}>
              Cost of Check
            </H6>
            <Span sx={styles.labelValue}>
              {data?.service_cost
                ? figureFormatter({
                    figure: data?.service_cost,
                    currency: data?.currency?.currency,
                  })
                : "---"}
            </Span>
          </Grid>
        </Grid>
      </Box>

      {[5].includes(data?.status) && (
        <FlexBox alignItems={"center"} justifyContent={"flex-start"} gap={2}>
          <Button
            size="small"
            color="inherit"
            variant="contained"
            sx={{ backgroundColor: "#FFFFFF", border: "1px solid #D9D9D9" }}
            onClick={handleTryAgain ? handleTryAgain : () => {}}
          >
            Try Again
          </Button>
        </FlexBox>
      )}
    </Box>
  );
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "1rem",
    backgroundColor: "#EFEFEF",
    borderRadius: "0.5rem",
  },
  labelText: {
    fontSize: "0.8rem",
    fontWeight: 400,
    color: "#000000",
  },
  labelValue: {
    fontSize: "1rem",
    fontWeight: 500,
    color: "#5F6368",
  },
  iconCircle: {
    height: "4rem",
    width: "4rem",
    backgroundColor: "#FFFFFF",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
};

export default ResultsNIN;
